import Link from 'next/link'
import { ReactNode } from 'react'
import styled from 'styled-components'

import Button, { IconContainer } from '../../Buttons/Circle/Button'
import SVGArrowLeft from '../../Svg/ArrowLeft'
import { ArrowRight as SVGArrowRight } from '../../Svg/ArrowRight'
import SVGExitDoor from '../../Svg/ExitDoor'

interface RoomLinkProps {
  href: string
  children: ReactNode
  className?: string
}
const RoomLink = ({ href, children, className }: RoomLinkProps) => (
  // <Link passHref href={href}>
  <RoomLinkA href={href} className={className}>
    {children}
  </RoomLinkA>
  // </Link>
)
interface RoomNavigatorProps {
  hrefDoor: string
  hrefBack?: string
  hrefForward?: string
}
export const RoomNavigator: React.FC<RoomNavigatorProps> = ({ hrefDoor, hrefBack, hrefForward }: RoomNavigatorProps) => (
  <Container>
    {hrefBack && (
      <RoomLink href={hrefBack}>
        <IconContainer>
          <span className="sr-only">Go to previous room</span>
          <SVGArrowLeft width="53.33334%" />
        </IconContainer>
      </RoomLink>
    )}

    {hrefForward && (
      <RoomLink href={hrefForward}>
        <IconContainer>
          <span className="sr-only">Go to next room</span>
          <SVGArrowRight width="53.33334%" />
        </IconContainer>
      </RoomLink>
    )}

    <RoomLink className="exit-door" href={hrefDoor}>
      <IconContainer>
        <span className="sr-only">Go to overview room</span>
        <SVGExitDoor width="53.33334%" />
      </IconContainer>
    </RoomLink>
  </Container>
)

export default RoomNavigator

const Container = styled.nav`
  position: absolute;
  bottom: 30px;
  right: 30px;
  display: flex;

  ${Button} {
    margin-right: 10px;

    &.exit-door {
      margin-right: 0;
      margin-left: 10px;
    }
  }
`

const RoomLinkA = styled.a`
  display:block;
  border: none;
  margin: 0;
  font-style: normal;
  font-weight: bold;
  cursor: pointer;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0;
  margin-right: 5px;

  background: #fff;
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  color: ${({ theme }) => theme.colors.black};

  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);

  font-size: max(13px, 0.9vw);
  border-radius: 1.73077em;
  /* padding: 0 1.53em; */
  padding: 0;
  height: 3.125vw;
  width: 3.125vw;
  min-height: 45px;
  min-width: 45px;
  line-height: 1.385em;

  &:focus,
  &:active {
    outline: none;
  }
`
